<template>
  <div  class="sidebar border d-flex align-items-center" style="padding: 10px;">
    <b-row>
      <b-col>
          <birthday-cake style="margin-left: 75px"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BirthdayCake  from "@/components/common/birthdayCake"
export default {
  name: "Side_Bar",
  components:{
    BirthdayCake
  },
  data() {
    return {
      parentHeight: null
    };
  },
  methods: {
    sidebarHeight() {
      this.parentHeight = this.$parent.$el.offsetHeight;
      // this.parentHeight = this.$parent.$el.offsetHeight
      document.querySelector(".sidebar").style.height =
        this.parentHeight + "px";
    },
    handleClick: function(clickName) {
      this.$router.push(clickName);
    },
    handleHomeClick() {
      this.$router.push("/");
    }
  },
  mounted() {
    if (window.innerWidth > 862) {
       //this.sidebarHeight();
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth > 862) {
        //this.sidebarHeight();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
$bp-sm: 576px;
$bp-md: 768px;
$bp-tab: 862px;
$bp-lg: 992px;
$bp-lap: 1024px;
$bp-xl: 1200px;

.logo {
  cursor: pointer;
}
.sidebar {
  padding: 4rem 3rem;
  background-color: var(--theme-color);
  width: 34%;
  float: left;
  height: 100vh;

  a {
    &:hover {
      box-shadow: none;
    }
  }
  .display-img {
    height: calc(100vh - 300px);
  }
  .text-box {
    // height: calc(100vh - 120px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: var(--theme-contrast-text);
    .title-text {
      color: var(--theme-contrast-text);
      font-weight: bold;
      font-size: 32px;
      line-height: 1.2;
      margin-bottom: 16px;
      // transform: translateY(-50%);
    }
    .subtext {
      // transform: translateY(-50%);
      font-weight: normal;
      font-weight: 400;
      font-size: 16px;
      color: var(--theme-contrast-text);
      opacity: 0.7;
    }
  }
}
@media (max-width: $bp-xl) {
  .sidebar {
    .text-box {
      .title-text {
        transform: none;
      }
      .subtext {
        transform: none;
      }
    }
  }
}
@media (max-width: $bp-lap) {
  .sidebar {
    width: 40%;
    padding: 4rem 2rem;
  }
}
@media (max-width: $bp-tab) {
  .sidebar {
    width: 100%;
    height: auto !important;
    padding: 4rem;
    float: unset;
    .display-img {
      height: 200px;
      margin: 0 auto;
    }
    .text-box {
      height: 100%;
      // margin-top: 60px;
    }
  }
}
@media (max-width: $bp-sm) {
  .sidebar {
    .text-box {
      .title-text {
        font-size: 32px;
        margin-bottom: 20px;
        line-height: 38px;
      }
      .subtext {
        font-size: 18px;
      }
    }
  }
}
</style>
